import React from "react";
import { Filter, TextInput } from "react-admin";

export const SearchFilter = props => (
  <Filter {...props}>
    <TextInput label="Pesquisar" source="search" alwaysOn />
  </Filter>
);
